import RMTabs from 'components/customComponents/Controls/RMTabs';
import { ITabItem } from 'components/tab/hooks';
import React from 'react';
import { EHarvestingView } from '../constants';
import HarvestCrystal from '../Crystal/HarvestCrystal';
import SelectSynchrotron from '../Synchrotron/SelectSynchrotron';
import { Cryoprotectant, Soaking } from '../protectantAgents';
import { useCrystalStates } from '../Crystal/hooks';
import SelectCryo from '../selectAgents/selectCryo';
import SelectSoaking from '../selectAgents/selectSoaking';

const HarvestingTabs = () => {
  const tabComponents: ITabItem[] = [
    {
      title: 'Crystal',
      eventKey: 'Crystal',
      content: <HarvestCrystal />,
    },
    {
      title: 'Cryoprotectant',
      eventKey: 'Cryoprotectant',
      content: <Cryoprotectant />,
    },
    {
      title: 'Soaking',
      eventKey: 'Soaking',
      content: <Soaking />,
    },
  ];
  const { harvestingContentView } = useCrystalStates();
  return (
    <>
      <div
        id="exp-harvestingtabs-container"
        style={{
          display: `${
            harvestingContentView === EHarvestingView.HARVESTING ? 'block' : 'none'
          }`,
        }}
      >
        <RMTabs
          tabItems={tabComponents}
          defaultActiveKey={'Crystal'}
          id={'exp-harvestingtabs-crystaltabs'}
        />
      </div>
      {harvestingContentView === EHarvestingView.SELECTTRIP ? (
        <div id="exp-harvestingtabs-selecttrip">
          <SelectSynchrotron id="exp-harvestingtabs-selectsynchrotron" />
        </div>
      ) : null}
      <div
        id="exp-harvestingtabs-selectcryo"
        style={{
          display: `${
            harvestingContentView === EHarvestingView.SELECTCRYO ? 'block' : 'none'
          }`,
        }}
      >
        <SelectCryo />
      </div>
      <div
        id="exp-harvestingtabs-selectsoaking"
        style={{
          display: `${
            harvestingContentView === EHarvestingView.SELECTSOAKING ? 'block' : 'none'
          }`,
        }}
      >
        <SelectSoaking />
      </div>
    </>
  );
};
export default HarvestingTabs;
